import { Eye, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRolePreview } from "@/contexts/RolePreviewContext";

export function RolePreviewBanner() {
  const { previewRole, isInPreviewMode, exitPreview } = useRolePreview();

  if (!isInPreviewMode) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-warning/95 text-warning-foreground px-4 py-2 flex items-center justify-between shadow-lg">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        <span className="font-semibold text-sm">
          Preview Mode: Viewing app as <span className="underline">{previewRole}</span>
        </span>
      </div>
      <Button
        size="sm"
        variant="ghost"
        onClick={exitPreview}
        className="hover:bg-warning-foreground/20 gap-1 h-7"
      >
        <X className="h-4 w-4" />
        Exit Preview
      </Button>
    </div>
  );
}
